import type { Selection } from 'react-aria-components';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import type { ZodEnum } from 'zod';

export function parsePreferencesFromSelection<T extends Record<string, boolean | undefined>>(
  selection: Selection,
  menuItemSchema: ZodEnum<[string, ...string[]]>,
): T {
  const preferences = {} as T;

  if (selection === 'all') {
    for (const item of menuItemSchema.options) {
      preferences[item as keyof T] = true as T[keyof T];
    }
    return preferences;
  }

  for (const item of selection) {
    try {
      const validatedItem = menuItemSchema.parse(String(item));
      preferences[validatedItem as keyof T] = true as T[keyof T];
    } catch {
      // ignore unknown items
    }
  }

  return preferences;
}
